import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { api } from '../api/client';
import { useAsync, Async } from '../components/Async';
import { Flag } from '../components/TeamBadge';
import { teamName } from '../lib/flags';
import { useStore } from '../stores/store';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
`;

const TeamBtn = styled.button<{ $fav: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme, $fav }) => ($fav ? theme.colors.gold : theme.colors.border)};
  border-radius: ${({ theme }) => theme.radius};
  padding: 10px 12px;
  text-align: left;
  span.nm { font-weight: 600; font-size: 0.86rem; }
  small { color: ${({ theme }) => theme.colors.textMuted}; display: block; }
`;

export function Teams() {
  const state = useAsync(() => api.teams(), [], '/teams');
  const navigate = useNavigate();
  const favorite = useStore((s) => s.favorite);

  return (
    <Async state={state}>
      {(d) => (
        <Grid>
          {d.teams.map((t) => (
            <TeamBtn
              key={t.name}
              $fav={t.name === favorite}
              onClick={() => navigate(`/team/${encodeURIComponent(t.name)}`)}
            >
              <Flag team={t.name} size={26} />
              <span>
                <span className="nm">{teamName(t.name)}</span>
                <small>Grupo {t.group}</small>
              </span>
            </TeamBtn>
          ))}
        </Grid>
      )}
    </Async>
  );
}
